import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "evrideo-copy-button",
  templateUrl: "./copy-button.component.html",
  styleUrls: ["./copy-button.component.scss"],
})
export class CopyButtonComponent implements OnInit {
  @Input()
  hoverClass = "";
  constructor() {}

  ngOnInit() {}
}
